<template>
  <v-card>
    <v-progress-linear indeterminate :active="fetching" color="primary"></v-progress-linear>
    <v-dialog v-model="delete_dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete property?</v-card-title>
        <v-card-text>Are you sure you want to delete property</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="delete_dialog = false">No</v-btn>
          <v-btn color="red" dark @click="deleteProperty">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat v-if="property">
      <v-list-item two-line class="px-0">
        <v-list-item-avatar>
          <v-icon dark color="primary">mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ full_name }}</v-list-item-title>
          <v-list-item-subtitle>{{property.owner_type}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn small color="primary" text rounded @click="showAuthor">
            <v-icon left>mdi-open-in-new</v-icon>Show
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-divider vertical></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Created At</v-list-item-title>
          <v-list-item-subtitle>{{property.created_at}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider vertical></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Status</v-list-item-title>
          <v-list-item-subtitle
            :class="`${property.status == 'published' ?  'primary': 'warning'}--text`"
          >{{property.status}}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            v-if="property.status != 'published'"
            rounded
            outlined
            text
            :loading="fetching"
            color="primary"
            @click="publishProperty"
          >
            Publish
            <v-icon right>mdi-eye</v-icon>
          </v-btn>
          <v-btn
            :loading="fetching"
            color="primary"
            outlined
            v-else
            rounded
            text
            @click="unpublishProperty"
          >
            Unpublish
            <v-icon right>mdi-eye-off</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-divider vertical></v-divider>
      <v-list-item>
        <v-list-item-content></v-list-item-content>
        <v-list-item-action>
          <v-btn
            rounded
            outlined
            text
            :loading="fetching"
            @click="()=>delete_dialog = true"
            color="red"
          >
            Delete
            <v-icon right>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container v-if="property">
      <v-row>
        <v-col cols="12" md="8">
          <v-list-item three-line class="px-0">
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                <h1>{{ property.title }}</h1>
              </v-list-item-title>
              <v-list-item-subtitle>{{ trans('advert.property_type_' + property.property_type) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-row no-gutters class="mb-3">
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="primary">mdi-home</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Amount of rooms</v-list-item-title>
                  <v-list-item-subtitle>{{ property.room_amount }} rooms</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="primary">mdi-account-supervisor</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Amount of guests</v-list-item-title>
                  <v-list-item-subtitle>{{ property.occupants }} guests</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="primary">mdi-ruler-square</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ trans('advert.area') }}</v-list-item-title>
                  <v-list-item-subtitle>{{ property.area }} {{ trans('advert.area_unit_' + property.area_unit) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item two-line class="px-0">
                <v-list-item-avatar>
                  <v-icon dark color="primary">mdi-account-multiple-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Room Size</v-list-item-title>
                  <v-list-item-subtitle>{{ property.room_size || '-'}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">{{ trans('advert.view_description') }}</h2>
            <div>{{ property.description }}</div>
          </div>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="6">
              <div class="my-3 py-3">
                <h2 class="mb-3">{{ trans('advert.view_tenant_preferences') }}</h2>
                <tenant-preferences :advert="property"></tenant-preferences>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="my-3 py-3" v-if="property.property_type == 'room'">
                <h2 class="mb-3">{{ trans('advert.view_flatmate_preferences') }}</h2>
                <flatmate-preferences :advert="property"></flatmate-preferences>
              </div>
            </v-col>
          </v-row>

          <v-divider v-if="property.property_type == 'room'"></v-divider>
          <v-row>
            <v-col cols="6">
              <div class="my-3 py-3">
                <h2 class="mb-3">{{ trans('advert.view_amenities') }}</h2>
                <info-list type="amenities" :items="property.amenities"></info-list>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="my-3 py-3">
                <h2 class="mb-3">{{ trans('advert.view_facilities') }}</h2>
                <info-list type="facilities" :items="property.facilities"></info-list>
              </div>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <div class="my-3 py-3">
            <h2 class="mb-3">{{ trans('advert.transport_mode') }}</h2>
            <transport :item="property"></transport>
          </div>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" md="4" class="property-detail-price">
          <v-list-item two-line>
            <v-list-item-avatar>
              <v-icon dark color="primary">mdi-calendar</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">Available From</v-list-item-title>
              <v-list-item-subtitle>{{ property.available_from}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item two-line>
            <v-list-item-avatar>
              <v-icon dark color="primary">mdi-credit-card-check</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">Bills included</v-list-item-title>
              <v-list-item-subtitle>{{ property.bills_included}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item two-line>
            <v-list-item-avatar>
              <v-icon dark color="primary">mdi-cash</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">Price</v-list-item-title>
              <v-list-item-subtitle>{{ property.price_total}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item two-line>
            <v-list-item-avatar>
              <v-icon dark color="primary">mdi-calendar-month-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">Rent period</v-list-item-title>
              <v-list-item-subtitle>{{ property.rent_period}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-card-text>
            <div class="black--text">
              <span class="display-1" v-if="property.bills_included != 'yes'">~</span>
              <span class="display-1">{{ property.price_total }}</span>
              <span>{{ trans('advert.price_currency_'+property.price_currency) }} / {{ trans('advert.rent_period_'+property.rent_period) }}</span>
            </div>
          </v-card-text>-->

          <h3>Images</h3>
          <images-carousel :items="images" />
          <i v-if="images.length == 0">No images</i>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import InfoList from "../../components/property/InfoList";
import Transport from "../../components/property/Transport";
import TenantPreferences from "../../components/property/TenantPreferences";
import FlatmatePreferences from "../../components/property/FlatmatePreferences";
import ImagesCarousel from "../../components/property/ImagesCarousel";
import _ from "lodash";
export default {
  components: {
    "info-list": InfoList,
    "tenant-preferences": TenantPreferences,
    "flatmate-preferences": FlatmatePreferences,
    transport: Transport,
    "images-carousel": ImagesCarousel
  },
  data() {
    return {
      delete_dialog: false
    };
  },
  computed: {
    ...mapState("property", {
      fetching: "fetching",
      property: "property"
    }),
    full_name() {
      return (
        this.property.author.first_name + " " + this.property.author.last_name
      );
    },
    images() {
      let images = [];
      this.property.images.forEach(item => {
        images.push(item.sm);
      });
      return images;
    }
  },
  methods: {
    ...mapActions("property", {
      fetch: "show",
      publish: "publish",
      unpublish: "unpublish",
      clear: "clear",
      delete: "delete"
    }),
    showAuthor() {
      if (this.property.author) {
        this.$router.push({
          name: "users.show",
          params: { uuid: this.property.author.uuid }
        });
      }
    },
    deleteProperty() {
      this.delete(this.property.uuid).then(() => {
        this.$router.push({
          name: "property.list"
        });
      });
    },
    publishProperty() {
      this.publish(this.property.uuid).then(this.load);
    },
    unpublishProperty() {
      this.unpublish(this.property.uuid).then(this.load);
    },
    load() {
      if (this.$route.params.uuid) {
        this.fetch(this.$route.params.uuid);
      }
    }
  },
  mounted() {
    this.load();
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>

<style lang="scss" scoped></style>
